module.exports = (state = null, action) => action
